export const isEmpty = (objectToCheck) => {
    return Object.entries(objectToCheck).length === 0
}

export const imgUrl = (imgId) => {
    return `/lessors/DBImg.ashx?id=${imgId}`
}

export const fmtPrice = (price) => {
    return parseFloat(price || 0).toFixed(2);
}

export const fmtPercent = (percentage) => {
    return parseFloat(percentage || 0).toFixed(2);
}

export const isString = (testString) => {
    return (typeof testString === 'string' || testString instanceof String);
}

// export const fmtDatetime = (dateStr) => {
//     if (!dateStr) return '';

//     function pad(s) { return (s < 10) ? '0' + s : s; }
//     var d = new Date(dateStr);
//     var datePart = [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('.');
//     var timePart = pad(d.getHours()) + ':' + pad(d.getMinutes());
//     return datePart + ' - ' + timePart;
// }

export const roundMinutes = (input) => {
    var date = (input instanceof Date) ? input : new Date(input);
    var coeff = 1000 * 60 * 5;
    return new Date(Math.round(date.getTime() / coeff) * coeff);
}

export const fmtDatetime = (date) => {
    if (!date) return '';
    let datePart = date.toLocaleDateString('de-CH', { year: 'numeric', month: 'short', day: '2-digit' });
    let timePart = date.toLocaleTimeString('de-CH', { hour: '2-digit', minute: '2-digit' });
    return datePart + ' - ' + timePart;
}

export const fmtDate = (dateStr) => {
    if (!dateStr) return '';

    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(dateStr);
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('.');
}

export const genGuid = () => { // Public Domain/MIT
    var d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

export const isValidEmail = (input) => {
    if (!input || input === '') return false;
    return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,12})+$/.test(input));
}